import { render, staticRenderFns } from "./StatementPrint.vue?vue&type=template&id=252f1b70"
import script from "./StatementPrint.vue?vue&type=script&lang=js"
export * from "./StatementPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports